module.exports = __webpack_public_path__ + "static/media/Login-box-bgsp.878ac7b1.jpg";